module.exports = "<div class=\"modal-header\">\n    <button type=\"button\"\n            data-dismiss=\"modal\"\n            aria-hidden=\"true\"\n            class=\"close\"\n            ng-click=\"ctrl.cancel()\">\n    </button>\n    <h4 class=\"modal-title\"\n        ng-bind=\"ctrl.title\">\n    </h4>\n</div>\n<div class=\"modal-body\"\n     ng-bind-html=\"ctrl.body\">\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/common/components/infoPopup/infoPopup.component.html
// module id = 630
// module chunks = 6